import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function Steps({ children }) {
  var currentStep = 1;

  // we can't use React.Children.count because sometimes a child is null, and we don't want to count it
  var count = 0;

  var steps = React.Children.map(children, (child, i) => {
    if (child === null) {
      return null;
    }
    count++;
    if (child.props.selected) {
      currentStep = i + 1;
    }
    return (
      <li className="steps_cell">
        {child}
      </li>
    );
  });
  return (
    <div className={classes({
      "steps": true,
      ["steps--has-" + count]: true,
      ["steps--is-step-" + currentStep]: true
    })}>
      <i className="dw-horse-running-jockey steps_icon-indicator" />

      <i className="dw-flag-checkered steps_icon-finish" />

      <ul className="steps_table">
        {steps}
      </ul>
    </div>
  );
});
